const STORAGE_KEY = 'rps_player_id';

function generatePlayerId(): string {
  return 'Player_' + Math.random().toString(36).slice(2, 8);
}

/**
 * The player id doubles as the display name and as the DynamoDB partition key
 * for reconnects, so it must survive a page reload.
 */
export function getOrCreatePlayerId(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
    const id = generatePlayerId();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // Private browsing / blocked storage: fall back to a session-only id.
    return generatePlayerId();
  }
}

export function savePlayerId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* storage unavailable — the id stays in React state for this session */
  }
}

export function truncateName(name: string, max = 12): string {
  return name.length > max ? name.slice(0, max - 1) + '…' : name;
}
